import axios, { AxiosError } from "axios";
import { RelationshipTypeEnum } from "./Representation";
const TenantPartnershipResource = {
    getTenantPartnership(sourceTenantId, relationTenantId, relationshipType, resultFunc, errorFunc, finallyFunc) {
        axios.get(`/admin/v1/tenants/${sourceTenantId}/partnerships/${relationTenantId}/${relationshipType}`)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    getTenantCustomerOfPartnerships(relationTenantId, resultFunc, errorFunc, finallyFunc) {
        axios.get(`/admin/v1/tenants/${relationTenantId}/partnerships/customer-of`)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    create(sourceTenantId, request, resultFunc, errorFunc, finallyFunc) {
        axios.post(`/admin/v1/tenants/${sourceTenantId}/partnerships`, request)
            .then((response) => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    patchPartnershipCanViewDockets(sourceTenantId, relationTenantId, canViewPickupDockets, resultFunc, errorFunc, finallyFunc) {
        const strCanViewPickupDockets = canViewPickupDockets ? "true" : "false";
        axios.patch(`/admin/v1/tenants/${sourceTenantId}/partnerships/${relationTenantId}/can-view-pickup-dockets/${strCanViewPickupDockets}`)
            .then((response) => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    patchPartnershipTierRating(sourceTenantId, relationTenantId, tierRating, resultFunc, errorFunc, finallyFunc) {
        axios.patch(`/admin/v1/tenants/${sourceTenantId}/partnerships/${relationTenantId}/tier-rating/${tierRating}`)
            .then((response) => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    patchPartnershipBlocked(sourceTenantId, relationTenantId, relationship, blocked, resultFunc, errorFunc, finallyFunc) {
        const strBlocked = blocked ? "true" : "false";
        axios.patch(`/admin/v1/tenants/${sourceTenantId}/partnerships/${relationTenantId}/type/${relationship}/blocked/${strBlocked}`)
            .then((response) => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
};
export default TenantPartnershipResource;
